import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import APIS from "../utils/APIS"

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Home | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="md" sx={{
          display:"flex",
          padding: "0 !important",
          justifyContent:"center",
          gap:["20px", "50px", "70px"],
          flexWrap:"wrap",
          zIndex:1,
          overflow:"auto",
          marginBottom:"10px",
        }}>

          <Box sx={{
            background:"white",
            border: "1px solid #E7E7E7",
            width:["350px", "450px"],
            maxWidth:"100%",
            padding:"30px 20px",
          }}>
            <Box sx={{
              fontSize:["26px", "32px", "36px"],
              fontWeight:500,
              textAlign:"center",
              color : "text.black"
            }}>
              Pour les recruteurs
            </Box>
            <Box sx={{
              fontSize:["14px", "16px", "18px"],
              textAlign:"center",
              marginTop:["10px", "10px", "25px"],
              color : "text.primary"
            }}>
            <b>Vos candidats en un coup d’œil :</b> Suivez l’avancement des tests et visualisez la compatibilité comportementale de vos candidats.
            </Box>
            <Box sx={{display:"flex", justifyContent:"center", marginTop:["15px", "15px", "35px"], marginBottom:["25px", "25px", "55px"]}}>
              <RouterLink to="/login">
                <Button
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  endIcon={<ChevronRightIcon/>}
                >
                  Se connecter
                </Button>
              </RouterLink>
            </Box>
            <Box sx={{
              fontSize:"16px",
              textAlign:"center",
              color : "text.primary",
            }}>
              Vous n'avez pas de compte ?
              <Link component={RouterLink} to="/sign-up" sx={{marginLeft:"3px"}}>
                Inscrivez-vous
              </Link>
            </Box>
          </Box>

          <Box sx={{
            background:"white",
            border: "1px solid #E7E7E7",
            width:["350px", "450px"],
            maxWidth:"100%",
            padding:"30px 20px",
          }}>
            <Box sx={{
              fontSize:["26px", "32px", "36px"],
              fontWeight:500,
              textAlign:"center",
              color : "text.black"
            }}>
              Pour les candidats
            </Box>
            <Box sx={{
              fontSize:["14px", "16px", "18px"],
              textAlign:"center",
              marginTop:["10px", "10px", "25px"],
              color : "text.primary"
            }}>
              <b>Bienvenue dans The Scan :</b> Ce test explore vos soft skills clés pour ce poste. Comptez ~20 min pour le compléter.
            </Box>
            <Box sx={{display:"flex", justifyContent:"center", marginTop:["15px", "15px", "35px"], marginBottom:["25px", "25px", "55px"]}}>
              <RouterLink to="/login">
                  <Button
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Se connecter
                  </Button>
              </RouterLink>
            </Box>
            <Box sx={{
              fontSize:"16px",
              textAlign:"center",
              color : "text.primary",
              visibility: "hidden",
            }}>
              Vous n'avez pas de compte ?
              <Link component={RouterLink} to="/sign-up" sx={{marginLeft:"3px"}}>
                Inscrivez-vous
              </Link>
            </Box>
          </Box>


        </Container>
      </Box>
    </>
  );
};

export default Home;
